/**
 * The reasoning chip's value, shared by every composer (#111) — the React face
 * of `reasoningEffortStore`.
 */
import { useCallback, useSyncExternalStore } from "react";
import type { ReasoningEffort } from "../lib/models";
import { reasoningEffortStore } from "../lib/reasoningEffortStore";

export function useReasoningEffort(): [ReasoningEffort, (next: ReasoningEffort) => void] {
  const value = useSyncExternalStore(
    reasoningEffortStore.subscribe,
    reasoningEffortStore.read,
    reasoningEffortStore.read,
  );
  const set = useCallback((next: ReasoningEffort) => reasoningEffortStore.set(next), []);
  return [value, set];
}
